/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Completed_SuccessInputs */



/**
* | output |
* | --- |
* | "Automatic save completed successfully" |
*
* @param {Automatic_Save_Completed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_completed_success = /** @type {((inputs?: Automatic_Save_Completed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Completed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarde automatique terminée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisches Speichern erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio automatico completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое сохранение успешно завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardado automático completado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动保存已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動保存が正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सेव सफलतापूर्वक पूरा हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvamento automático concluído com sucesso.")
	return /** @type {LocalizedString} */ ("Automatic save completed successfully")
});